import {Component, Input } from '@angular/core';
import * as Models from 'app/core/models';
import {ProcessAuthorizationType} from 'app/core/models/process.model';

@Component({
  selector: 'app-set-audience',
  templateUrl: './set-audience.component.html',
  styleUrls: ['./set-audience.component.scss']

})

export class SetAudienceComponent {
  @Input() processAuthorization;
  @Input() processId: number;


  constructor() {
  }


}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/publishProcessModal/setAudience/setAudience.component.ts